<template>
  <div class="nav__title -main">
    <slot></slot>
    <i
      class="ico--arr-down"
      v-if="this.$parent.withSubNav"
    >
    </i>
    <router-link :to="path || subnavPath"></router-link>
  </div>
</template>

<script>
export default {
  name: 'nav-title',

  props: {
    path: ''
  },

  data () {
    return {
      subnavPath: '',
      defaultPath: null,
      routePath: null
    }
  },

  inject: {
    handleNav: {}
  },

  watch: {
    // async '$route' ($router) {
    //   this.validateRoute()
    // },
    //
    // routePath () {
    //   if (this.routePath) {
    //     if (this.routePath === this.defaultPath) {
    //       this.$parent.active = true
    //       this.handleNav.group = this.$parent.group
    //     }
    //   } else {
    //     this.$parent.active = false
    //   }
    // }
  },

  mounted () {
    this.$nextTick(() => {
      this.$parent.defaultPath = this.defaultPath
    })
  },

  methods: {
    // validateRoute () {
    //   var routeArr = []
    //
    //   if (this.defaultPath) {
    //     let defaultPath = this.defaultPath.split('/').filter(function (e) { return e })
    //     let route = this.$route.path.split('/').filter(function (e) { return e })
    //
    //     for (var i = 0; i < route.length; i++) {
    //       if (defaultPath.indexOf(route[i]) > -1) {
    //         routeArr.push(route[i])
    //       }
    //     }
    //
    //     this.routePath = null
    //
    //     if (defaultPath.length === routeArr.length) {
    //       this.routePath = '/' + routeArr.join('/')
    //     }
    //   }
    // }
  }
}
</script>
